<template>
  <div>
    <!-- <div>field: {{ field }}</div> -->
    <!-- <div>field.attachments.length: {{ field.attachments.length }}</div> -->
    <!-- <div>hasAttachments: {{ hasAttachments }}</div> -->

    <base-row-detail
      :label="field.fieldName"
      :value="field.fieldValue"
    ></base-row-detail>

    <div v-if="hasAttachments">
      <b-button v-if="!isShowingAttachment" size="sm" @click="showAttachment()">
        {{ $t("geral.showAttachments") }}
      </b-button>
      <b-button v-if="isShowingAttachment" size="sm" @click="hideAttachment()">
        {{ $t("geral.hideAttachments") }}
      </b-button>
    </div>

    <div v-if="isShowingAttachment">
      <div v-for="attachment in field.attachments" :key="attachment.id">
        <div v-if="isAttachmentImage(attachment)">
          <authed-image
            id="authed-image"
            :attachmentSrc="`${$store.getters.urlWorkflow}/v1/filled/field/attachment/${attachment.id}`"
            :attachmentId="attachment.id"
            :attachmentName="attachment.attachmentName"
            :discard-visible="false"
            :token="$store.getters.token"
          />
        </div>
        <div v-else-if="isAttachmentVideo(attachment)">
          <authed-video
            id="authed-video"
            :attachmentSrc="attachment.attachment"
            :attachmentUrl="`${$store.getters.urlWorkflow}/v1/filled/field/attachment/${attachment.id}`"
            :attachmentId="attachment.id"
            :attachmentName="attachment.attachmentName"
            :discard-visible="false"
            :token="$store.getters.token"
          />
        </div>
        <div v-else>
          <authed-document
            id="authed-video"
            :attachmentSrc="`${$store.getters.urlWorkflow}/v1/filled/field/attachment/${attachment.id}`"
            :attachmentId="attachment.id"
            :attachmentName="attachment.attachmentName"
            :discard-visible="false"
            :token="$store.getters.token"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AuthedDocument from "@/components_rms/base/AuthedDocument.vue";
import AuthedImage from "@/components_rms/base/AuthedImage.vue";
import AuthedVideo from "@/components_rms/base/AuthedVideo.vue";
import BaseRowDetail from "@/components_rms/base/BaseRowDetail.vue";

export default {
  name: "FillingDetailsSummaryField",
  components: {
    AuthedDocument,
    AuthedImage,
    AuthedVideo,
    BaseRowDetail,
  },
  props: { field: Object },
  data() {
    return {
      isShowingAttachment: false,
    };
  },
  computed: {
    hasAttachments() {
      if (!this.field) return false;
      if (this.field == null) return false;
      if (this.field.attachments == null) return false;
      if (this.field.attachments.length == 0) return false;
      return true;
    },
  },
  methods: {
    hideAttachment() {
      this.isShowingAttachment = false;
      this.$emit("after-attachment-show");
    },
    isAttachmentImage(attachment) {
      if (attachment.attachmentName.endsWith(".jpeg")) return true;
      if (attachment.attachmentName.endsWith(".jpg")) return true;
      if (attachment.attachmentName.endsWith(".png")) return true;
      return false;
    },
    isAttachmentVideo(attachment) {
      return attachment.attachmentName.endsWith(".mp4");
    },
    showAttachment() {
      this.isShowingAttachment = true;
      this.$emit("after-attachment-show");
    },
  },
  watch: {},
};
</script>
